import * as api from "./api";
import { Category, getAuthToken } from "src/store/config";

interface ApiResponse {
  data: Category[];
  meta: {
    totalItems: number;
    itemsPerPage: number;
    totalPages: number;
    currentPage: number;
  };
}

// fetch list
export const fetchCategoryList = async (data: {
  search?: string;
  // page: number;
  // limit: number;
}): Promise<ApiResponse> => {
  const params:any = {
    // page: data.page,
    // limit: data.limit,
  };
  if (data.search) {
    params.search = data.search; 
  }
  const token = getAuthToken();
  api.setHeaderAuthorization(token);
  const response: any = await api.get(
    `${process.env.REACT_APP_ADMIN_API_URL}/prayer-categories`,
    params
  );
  return response;
};

// add category
export const addCategory = async (params: { title: string; image: string }) => {
  try {
    const token = getAuthToken();
    api.setHeaderAuthorization(token);
    const response = await api.post(
      `${process.env.REACT_APP_ADMIN_API_URL}/prayer-categories`,
      params
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// delete category
export const deleteCategory = (id: string) => {
  const token = getAuthToken();
  api.setHeaderAuthorization(token);
  return api.remove(
    `${process.env.REACT_APP_ADMIN_API_URL}/prayer-categories/${id}`
  );
};

// pinned-unpinned category
export const pinnedCategory = (id: string) => {
  const token = getAuthToken();
  api.setHeaderAuthorization(token);
  return api.put(`${process.env.REACT_APP_ADMIN_API_URL}/prayer-categories/pin/${id}`)
}

// store in temp
export const storeTemp = async (data:{path: string}) => {
  try {
    const token = getAuthToken();
    api.setHeaderAuthorization(token);
    const response = await api.post(
      `${process.env.REACT_APP_ADMIN_API_URL}/temp`,
      data
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// update category
export const updateCategory = async (
  id: string,
  params: { title: string; image: string,description: string, icon: string }
) => {
  try {
    const token = getAuthToken();
    api.setHeaderAuthorization(token);
    const response = await api.put(
      `${process.env.REACT_APP_ADMIN_API_URL}/prayer-categories/${id}`,
      params
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// change order category
export const reorderCategory = async (params: {
  categoryOrderDto: { pid: string; position: number }[];
}) => {
  try {
    const token = getAuthToken();
    api.setHeaderAuthorization(token);
    const response = await api.put(
      `${process.env.REACT_APP_ADMIN_API_URL}/prayer-categories/change-order`,
      params
    );
    return response;
  } catch (error) {
    throw error;
  }
};
